import React, { useState, useRef, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PricecollapseBox from "./PricecollapseBox";
import CurrencyFormat from "react-currency-format";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { extractDataFromInner } from "../../../../redux/reducers/utils.js";
import { handleShowDiscountsModal } from "../../../../action/index.js";
import { extractDataFromInsulation } from "../../../../helpers/insulation_pricing/insulationPricing.helper.js";

const CurrencyDisplay = ({ value, showPrefix = true }) => (
	<CurrencyFormat fixedDecimalScale="2" decimalSeparator="." decimalScale="2" value={value || 0} displayType={"text"} thousandSeparator={true} prefix={showPrefix ? "$" : ""} />
);

const PriceRow = ({ label, value, className = "", children = null }) => (
	<li className={className}>
		<aside className="deposit-price-label">{label}</aside>
		<aside className="deposit-price-value">{children || <CurrencyDisplay value={value} />}</aside>
	</li>
);

const Prices = () => {
	const { const_var, params,isShowOverlay,incClickTime } = useSelector((state) => state.reducer);
  const dispatch = useDispatch();
	const [isMoreInfo, setIsMoreInfo] = useState(false);
	const [totalSummaryHeight, setTotalSummaryHeight] = useState(0);
	const [isSticky, setIsSticky] = useState(false);
	const [activeTab, setActiveTab] = useState("building");
	const ref = useRef(null);
	const buildingPriceArrar = const_var.BuildingPriceArrar;
  
	const stopparentclick = (e) => {
		e.stopPropagation();
	};

	const convertToTwoDecimalNumber = (price) => {
		price = parseFloat(price);
		let convertToTwoDecimal = Number.isInteger(price) ? price : price.toFixed(2);
		let convertToNumber = parseFloat(convertToTwoDecimal);

		return convertToNumber;
	};

	const setHeight = () => {
		let height = ref.current.getBoundingClientRect().height;
		setTotalSummaryHeight(height);
	};

	const stickyFooter = () => {
		const div = ref.current;
		if (div.scrollTop < div.scrollHeight - div.clientHeight) {
			setIsSticky(true);
		} else {
			setIsSticky(false);
		}
	};

	const moreInfoClick = () => {
		setHeight();
		setIsMoreInfo(!isMoreInfo);
	};

	const handleTabSelect = (key) => {
		setActiveTab(key);
	};

	useEffect(() => {
		stickyFooter();
	}, []);

	useEffect(() => {
		if (isShowOverlay !== undefined) {
			const timer = setTimeout(() => {
				setIsMoreInfo(false);
			}, 300);
			return () => clearTimeout(timer);
		}
	}, [isShowOverlay]);

	useEffect(() => {
		if (isShowOverlay) {
			setActiveTab("building");
		}
	}, [isShowOverlay]);

	useEffect(() => {
		if (incClickTime !== undefined) {
			setActiveTab("building");
		}
	}, [incClickTime]);

	let surValue = "";
	let surFlag = false;

	let moreInfoList = [
		{
			title: "Building Amount",
			detail: "Base + Height + Walls + Components + Extras Components Added Manually"
		},
		{
			title: "Manufacturer Discount",
			detail: "% Calculated on the Building Amount / $ Shown as added from the panel"
		},
		{
			title: "Sub Total",
			detail: "Building Total + Taxable Surcharge (if added) - Manufacturer Discount"
		},
		{
			title: "Dealer Deposit",
			detail: "% Calculated on the Subtotal / $ Shown as added from the panel."
		},
		{
			title: "Dealer Discount",
			detail: "Dealer discount calculated on the dealer deposit. % Calculated on the Dealer Deposit / $ Shown as added from the panel."
		},
		{
			title: "Card Processing Fee",
			detail: "Include in Order - the amount will be added to Down Payment. Included in Invoice Only - the amount will be shown only on the invoice and not added to Down Payment."
		},
		{
			title: "Down Payment",
			detail: "Dealer Deposit – Dealer Discount = Total + Credit Card Fee + Gravy"
		},
		{
			title: "Additional Charges",
			detail: "All the options from Notes & Extras + Non-taxable surcharges will be added to the additional charges except Gravy and CC processing fees.",
			subDetail: "Labor Fee - % Calculated on the Building Amount or Subtotal/$ shown as added by manufacturer."
		},
		{
			title: "Due Upon Installation",
			detail: "Sub Total – Dealer Deposit = Total + Taxes + Additional Charges"
		},
		{
			title: "Grand Total",
			detail: "Due upon Installation + Down Payment"
		}
	];

	const { permit } = const_var.post_data?.building?.order_extra_items || {};
	if (buildingPriceArrar?.["surcharge_amount"] && const_var?.stateManufacturerAcordingAPIDiscount?.["surcharge"]?.[params.m_s_n]) {
		if (const_var.post_data?.building?.surcharge_taxable != 0) {
			surValue = "(+Surcharge)";
		} else {
			surValue = "";
		}
		const surchargeData = const_var?.stateManufacturerAcordingAPIDiscount?.["surcharge"]?.[params?.m_s_n];
		if (params?.m_s_n && surchargeData != undefined && Object.keys(surchargeData).length > 0) {
			let surcharge_by_mfg = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter((data) => data.surcharge_on_discounted_subtotal == 1);
			if (surcharge_by_mfg.length > 0 || const_var?.post_data?.building?.surcharge_on_discounted_subtotal == 1) {
				surFlag = true;
			} else {
				surFlag = false;
			}
		}
	}

	let excludeBuildingAmaount = 0;
	if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
		if (buildingPriceArrar?.["order_total"] != undefined) {
			excludeBuildingAmaount = buildingPriceArrar?.["order_total"];
		}
		if (buildingPriceArrar?.["insulation_calculation"]) {
			excludeBuildingAmaount = excludeBuildingAmaount + buildingPriceArrar?.["insulation_calculation"].custom_insulation_total_amount;
		}
		if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
			excludeBuildingAmaount = excludeBuildingAmaount + buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_total_amount;
		}
	}
	let excludeDownpaymentAmaount = 0;
	if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
		if (buildingPriceArrar?.["down_payment_total"] != undefined) {
			excludeDownpaymentAmaount = buildingPriceArrar?.["down_payment_total"];
		}
		if (buildingPriceArrar?.["insulation_calculation"] != undefined) {
			excludeDownpaymentAmaount = excludeDownpaymentAmaount - buildingPriceArrar?.["insulation_calculation"].custom_insulation_down_payment_total;
		}
		if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
			excludeDownpaymentAmaount = excludeDownpaymentAmaount - buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_down_payment_total;
		}
	}

	const uniqueComponentObjects =
		const_var.thirdPartyComponent?.commissions?.garage && const_var.thirdPartyComponent?.commissions?.garage?.allDoorPrices > 0 ? extractDataFromInner(const_var.thirdPartyComponent.commissions.garage) : [];

	const uniqueInsulationObjects =
		const_var.thirdPartyComponent?.commissions?.insulation && const_var.thirdPartyComponent?.commissions?.insulation?.incTotalValue > 0
			? extractDataFromInsulation(const_var.thirdPartyComponent.commissions.insulation)
			: [];

	let totalOverheadTaxPrice = 0;
	const_var.post_data?.building?.tax &&
		Object.entries(const_var.post_data?.building?.tax)?.forEach(([key, val]) => {
			const overheadAmount = parseFloat(val.overhead_tax_amount);
			if (!isNaN(overheadAmount)) {
				totalOverheadTaxPrice += overheadAmount;
			}
		});

	return (
		<>
			<div onScroll={() => stickyFooter()} ref={ref} className={`prices-total-deposit price-deposit-section ${isSticky && "active-sticky"}`}>
				<Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mb-3" onClick={() => setIsMoreInfo(false)}>
					<Tab eventKey="building" title="Building">
						<ul>
							<PriceRow
								className="highlight-price"
								label={`Building Amount ${surFlag == false ? surValue : ""}`}
								value={
									buildingPriceArrar?.["order_total"] != undefined
										? buildingPriceArrar?.["order_total"] + (uniqueComponentObjects.length > 0 || uniqueInsulationObjects.length > 0 ? 0 : buildingPriceArrar?.["custom_subTotal"])
										: 0
								}
							/>

							<li className={buildingPriceArrar?.["discount_order_total"] != undefined ? "" : "d-none"}>
								<aside className="deposit-price-label">
									{const_var.crmSetting.is_hide_discount != false && const_var.manufacturer_discount_label != undefined && const_var.manufacturer_discount_label != "" ? (
										<>
											{const_var.offer_applied_name != "" ? (
												<>
													{const_var.manufacturer_discount_label + " : "}{" "}
													<span className="highlight-offer" onClick={() =>dispatch(handleShowDiscountsModal())}>
														{const_var.offer_applied_name}
														<i className="icon-next"></i>
													</span>
												</>
											) : (
												const_var.manufacturer_discount_label
											)}
										</>
									) : (
										"Manufacturer Discount"
									)}
								</aside>
								<aside className="deposit-price-value">
									<CurrencyDisplay value={buildingPriceArrar?.["discount_order_total"] != undefined ? buildingPriceArrar?.["discount_order_total"] : 0} />
								</aside>
							</li>

							<PriceRow
								className="highlight-deposit"
								label={`Sub Total ${surFlag == true ? surValue : ""}`}
								value={
									buildingPriceArrar?.["sub_order_total"] != undefined
										? parseFloat(buildingPriceArrar?.["sub_order_total"])?.toFixed(2) +
											(uniqueComponentObjects.length > 0 || uniqueInsulationObjects.length > 0 ? 0 : buildingPriceArrar?.["custom_subTotal"])
										: 0
								}
							/>

							<li className={buildingPriceArrar?.["has_grvy"] == 0 && buildingPriceArrar?.["grvy_value"] != 0 ? "" : " d-none"}>
								<aside className="deposit-price-label">Sub Total With Gravy</aside>
								<aside className="deposit-price-value">
									<CurrencyDisplay
										value={
											buildingPriceArrar?.["grvy_value"] != undefined
												? buildingPriceArrar?.["sub_order_total"] +
													(uniqueComponentObjects.length > 0 || uniqueInsulationObjects.length > 0 ? 0 : buildingPriceArrar?.["custom_subTotal"]) +
													buildingPriceArrar?.["grvy_value"]
												: 0
										}
									/>
								</aside>
							</li>

							<PriceRow
								className="highlight-price"
								label="Dealer Deposit"
								value={
									buildingPriceArrar?.["down_payment_total"] != undefined
										? buildingPriceArrar?.["down_payment_total"] + (uniqueComponentObjects.length > 0 || uniqueInsulationObjects.length > 0 ? 0 : buildingPriceArrar?.["custom_down_payment_total"])
										: 0
								}
							/>

							<li className={buildingPriceArrar?.["down_payment_discount_total"] != undefined ? "" : "d-none"}>
								<aside className="deposit-price-label">
									{" "}
									{const_var.dealer_discount_label != undefined && const_var.dealer_discount_label != "" ? const_var.dealer_discount_label : "Dealer Discount"}
								</aside>
								<aside className="deposit-price-value dealer-discount-formatting">
									{"$("}
									<CurrencyFormat
										fixedDecimalScale="2"
										decimalSeparator="."
										decimalScale="2"
										value={buildingPriceArrar?.["down_payment_discount_total"] != undefined ? buildingPriceArrar?.["down_payment_discount_total"] : 0}
										displayType={"text"}
										thousandSeparator={true}
									/>
									{")"}
								</aside>
							</li>

							<li className={buildingPriceArrar?.["processing_fee"] != undefined ? "" : "d-none"}>
								<aside className="deposit-price-label">Card Processing Fee</aside>
								<aside className="deposit-price-value">
									<CurrencyDisplay value={buildingPriceArrar?.["processing_fee"] != undefined ? buildingPriceArrar?.["processing_fee"] : 0} />
								</aside>
							</li>

							<li className={buildingPriceArrar?.["has_grvy"] == 1 || buildingPriceArrar?.["grvy_value"] == 0 ? "d-none" : ""}>
								<aside className="deposit-price-label">Gravy</aside>
								<aside className="deposit-price-value">
									<CurrencyDisplay value={buildingPriceArrar?.["grvy_value"] != undefined ? buildingPriceArrar?.["grvy_value"] : 0} />
								</aside>
							</li>

							<PriceRow
								className="highlight-deposit"
								label="Down Payment"
								value={
									buildingPriceArrar?.["new_down_payment_total"] != undefined
										? buildingPriceArrar?.["new_down_payment_total"] +
											(uniqueComponentObjects.length > 0 || uniqueInsulationObjects.length > 0 ? 0 : buildingPriceArrar?.["custom_down_payment_total"]) +
											buildingPriceArrar?.["grvy_value"]
										: 0
								}
							/>

							<li className={const_var.loginSession == true ? "highlight-deposit d-none" : "d-none"}>
								<aside className="deposit-price-label">Tax on Sub Total</aside>
							</li>

							{const_var.loginSession == true && const_var.post_data.building != undefined
								? Object.entries(const_var.post_data.building.tax).map((val, key) => {
										let insulationPrice = 0;
										let overheadPrice = 0;
										let commonPrice = 0;
										let BuildingINCAmount = 0;
										if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
											if (val[1].amount != undefined) {
												commonPrice = parseFloat(val[1].amount);
												BuildingINCAmount = val[1].amount;
											}
											if (buildingPriceArrar?.["insulation_calculation"] != undefined) {
												commonPrice = val[1].insulation_tax_amount != undefined ? parseFloat(commonPrice) + 0 : parseFloat(commonPrice) + 0;
												insulationPrice = val[1].insulation_tax_amount != undefined ? val[1].insulation_tax_amount : 0;
											}
											if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
												commonPrice = val[1].overhead_tax_amount != undefined ? parseFloat(commonPrice) + 0 : parseFloat(commonPrice) + 0;
												overheadPrice = val[1].overhead_tax_amount != undefined ? val[1].overhead_tax_amount : 0;
											}
										}
										return (
											<>
												{buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined ? (
													<li className="highlight-price">
														<aside className="deposit-price-label">
															<span className="text">{const_var.othertaxDropDownValue[val[1].name]}</span>
														</aside>
														<aside className="deposit-price-value">
															<CurrencyDisplay value={commonPrice} />
														</aside>
													</li>
												) : (
													<>
														{val != undefined && val[1].amount != undefined && val[1].amount != 0 ? (
															<li className="highlight-price">
																<aside className="deposit-price-label">{const_var.othertaxDropDownValue[val[1].name]}</aside>
																<aside className="deposit-price-value">
																	<CurrencyDisplay value={val[1].amount != undefined ? val[1].amount : 0} />
																</aside>
															</li>
														) : null}
													</>
												)}
											</>
										);
									})
								: null}

							<PriceRow
								className={const_var.loginSession == true ? "" : ""}
								label="Additional Charges"
								value={buildingPriceArrar?.["additional_charges"] != undefined ? buildingPriceArrar?.["additional_charges"] : 0}
							/>

							<li className="deposit-price-label">
								<aside className="deposit-price-label">
									Due Upon Installation
									{uniqueComponentObjects.length > 0 || uniqueInsulationObjects?.length > 0 ? (
										<div className="deposit-sub-label">
											({(uniqueComponentObjects.length > 0 || uniqueInsulationObjects?.length > 0) && "Inc. "}
											{uniqueComponentObjects.length > 0 && "Doors"}
											{uniqueComponentObjects.length > 0 && uniqueInsulationObjects?.length > 0 && " & "}
											{uniqueInsulationObjects?.length > 0 && "Insulation"})
										</div>
									) : null}
								</aside>
								<aside className="deposit-price-value">
									<CurrencyDisplay value={const_var.post_data.building != undefined ? const_var.post_data.building.due_upon_installation : 0} />
								</aside>
							</li>
						</ul>
					</Tab>
					{uniqueComponentObjects.length > 0 && (
						<Tab eventKey="door" title="Door" className="door-tab">
							<ul>
								{uniqueComponentObjects?.length > 0 ? (
									uniqueComponentObjects.map((item) => {
										return (
											<li className={"highlight-price"} key={item.id || item.name}>
												<aside className="deposit-price-label">{item.name}</aside>
												<aside className="deposit-price-value">
													<CurrencyDisplay value={item.itemPrice != undefined ? parseFloat(item.itemPrice) : 0} />
												</aside>
											</li>
										);
									})
								) : (
									<li key="overhead-door" className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-price"}>
										<aside className="deposit-price-label">Overhead Door</aside>
										<aside className="deposit-price-value">
											${buildingPriceArrar?.["overhead_door_calculation"] != undefined ? buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_total_amount : 0}
										</aside>
									</li>
								)}
								{uniqueComponentObjects?.length > 0 ? (
									<>
										<li className="highlight-deposit">
											<aside className="deposit-price-label">
												Sub Total{" "}
												{const_var.thirdPartyComponent?.surcharge?.garage?.surchargeTaxable &&
												const_var.thirdPartyPricesObj?.garage?.garage_subtotal != const_var.thirdPartyPricesObj?.garage?.garage_total_val
													? "(+Surcharge)"
													: ""}
											</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay
													value={
														const_var.thirdPartyComponent?.surcharge?.garage?.surchargeTaxable
															? const_var.thirdPartyPricesObj?.garage?.garage_subtotal || 0
															: const_var.thirdPartyPricesObj?.garage?.garage_total_val || 0
													}
												/>
											</aside>
										</li>
										<li className={"highlight-price"}>
											<aside className="deposit-price-label">Door Deposit</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyPricesObj?.garage?.garage_commission_amount || 0} />
											</aside>
										</li>
										{const_var.loginSession == true && const_var.post_data.building != undefined
											? uniqueComponentObjects.length > 0
												? Object.entries(const_var.thirdPartyComponent.tax.garage)?.map((val, key) => {
														return (
															<li className="highlight-price" key={key}>
																<aside className="deposit-price-label" style={{ textTransform: "capitalize" }}>
																	{val?.[1].name}
																</aside>
																<aside className="deposit-price-value">
																	<CurrencyDisplay value={val[1].tax_amount ? parseFloat(val[1].tax_amount) : 0} />
																</aside>
															</li>
														);
													})
												: Object.entries(const_var.post_data.building.tax).map((val, key) => {
														let insulationPrice = 0;
														let overheadPrice = 0;
														let commonPrice = 0;
														let BuildingINCAmount = 0;
														if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
															if (val[1].amount != undefined) {
																commonPrice = parseFloat(val[1].amount);
																BuildingINCAmount = val[1].amount;
															}
															if (buildingPriceArrar?.["insulation_calculation"] != undefined) {
																commonPrice = val[1].insulation_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].insulation_tax_amount) : parseFloat(commonPrice) + 0;
																insulationPrice = val[1].insulation_tax_amount != undefined ? val[1].insulation_tax_amount : 0;
															}
															if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
																commonPrice = val[1].overhead_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].overhead_tax_amount) : parseFloat(commonPrice) + 0;
																overheadPrice = val[1].overhead_tax_amount != undefined ? val[1].overhead_tax_amount : 0;
															}
														}
														return (
															<>
																{buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined ? (
																	<li key={key} className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-price"}>
																		<aside className="deposit-price-label">{const_var.othertaxDropDownValue[val[1].name]}</aside>
																		<aside className="deposit-price-value">
																			<CurrencyDisplay value={buildingPriceArrar?.["overhead_door_calculation"] != undefined ? overheadPrice : 0} />
																		</aside>
																	</li>
																) : (
																	""
																)}
															</>
														);
													})
											: null}
										<li className={const_var.thirdPartyPricesObj?.garage?.garage_add_val > 0 ? "highlight-price" : "d-none"}>
											<aside className="deposit-price-label">Additional Charges</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyPricesObj?.garage?.garage_add_val || 0} />
											</aside>
										</li>
									</>
								) : (
									<>
										<li className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-deposit"}>
											<aside className="deposit-price-label">Sub Total</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay
													value={buildingPriceArrar?.["overhead_door_calculation"] != undefined ? parseFloat(buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_total_amount) : 0}
												/>
											</aside>
										</li>
										<li className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-price"}>
											<aside className="deposit-price-label">Door Deposit</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay
													value={buildingPriceArrar?.["overhead_door_calculation"] != undefined ? buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_down_payment_total : 0}
												/>
											</aside>
										</li>
										{const_var.loginSession == true && const_var.post_data.building != undefined
											? uniqueComponentObjects.length > 0
												? Object.entries(const_var.thirdPartyComponent.tax.garage)?.map((val, key) => {
														return (
															<li className="highlight-price" key={key}>
																<aside className="deposit-price-label" style={{ textTransform: "capitalize" }}>
																	{val?.[1].name}
																</aside>
																<aside className="deposit-price-value">
																	<CurrencyDisplay value={val[1].tax_amount ? val[1].tax_amount : 0} />
																</aside>
															</li>
														);
													})
												: Object.entries(const_var.post_data.building.tax).map((val, key) => {
														let insulationPrice = 0;
														let overheadPrice = 0;
														let commonPrice = 0;
														let BuildingINCAmount = 0;
														if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
															if (val[1].amount != undefined) {
																commonPrice = parseFloat(val[1].amount);
																BuildingINCAmount = val[1].amount;
															}
															if (buildingPriceArrar?.["insulation_calculation"] != undefined) {
																commonPrice = val[1].insulation_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].insulation_tax_amount) : parseFloat(commonPrice) + 0;
																insulationPrice = val[1].insulation_tax_amount != undefined ? val[1].insulation_tax_amount : 0;
															}
															if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
																commonPrice = val[1].overhead_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].overhead_tax_amount) : parseFloat(commonPrice) + 0;
																overheadPrice = val[1].overhead_tax_amount != undefined ? val[1].overhead_tax_amount : 0;
															}
														}
														return (
															<>
																{buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined ? (
																	<li key={key} className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-price"}>
																		<aside className="deposit-price-label">{const_var.othertaxDropDownValue[val[1].name]}</aside>
																		<aside className="deposit-price-value">
																			<CurrencyDisplay value={buildingPriceArrar?.["overhead_door_calculation"] != undefined ? overheadPrice : 0} />
																		</aside>
																	</li>
																) : (
																	""
																)}
															</>
														);
													})
											: null}
									</>
								)}
								{uniqueComponentObjects?.length > 0 ? (
									<li className={"highlight-deposit"}>
										<aside className="deposit-price-label">Due Amount</aside>
										<aside className="deposit-price-value">
											<CurrencyDisplay value={const_var.thirdPartyPricesObj?.garage?.garage_due_amount || 0} />
										</aside>
									</li>
								) : (
									<li className={buildingPriceArrar?.["overhead_door_calculation"] == undefined ? "d-none" : "highlight-deposit"}>
										<aside className="deposit-price-label">Due Amount</aside>
										<aside className="deposit-price-value">
											<CurrencyDisplay
												value={
													buildingPriceArrar?.["overhead_door_calculation"] != undefined
														? buildingPriceArrar?.["overhead_door_calculation"].custom_overhead_total_amount -
															parseFloat(buildingPriceArrar?.["overhead_door_calculation"]?.custom_overhead_down_payment_total || 0) +
															(totalOverheadTaxPrice || 0)
														: 0
												}
											/>
										</aside>
									</li>
								)}
							</ul>
						</Tab>
					)}
					{uniqueInsulationObjects.length > 0 && (
						<Tab eventKey="insulation" title="Insulation" className="insulation-tab">
							<ul>
								{uniqueInsulationObjects.length > 0 ? (
									<>
										<li className="highlight-price">
											<aside className="deposit-price-label">Insulation Charges</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyPricesObj?.insulation?.inc_total_val || 0} />
											</aside>
										</li>
										<li className="highlight-deposit">
											<aside className="deposit-price-label">
												Sub Total{" "}
												{const_var.thirdPartyComponent?.surcharge?.insulation?.surchargeTaxable &&
												const_var.thirdPartyPricesObj?.insulation?.inc_total_val != const_var.thirdPartyPricesObj?.insulation?.inc_subtotal
													? "(+Surcharge)"
													: ""}
											</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay
													value={
														const_var.thirdPartyComponent?.surcharge?.insulation?.surchargeTaxable
															? const_var.thirdPartyPricesObj?.insulation?.inc_subtotal || 0
															: const_var.thirdPartyPricesObj?.insulation?.inc_total_val || 0
													}
												/>
											</aside>
										</li>
										<li className="highlight-price">
											<aside className="deposit-price-label">Insulation Deposit</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyPricesObj?.insulation?.inc_commission_amount || 0} />
											</aside>
										</li>
									</>
								) : (
									<>
										<li className={buildingPriceArrar?.["insulation_calculation"] == undefined ? "d-none" : "highlight-price"}>
											<aside className="deposit-price-label">Insulation Charges</aside>
											<aside className="deposit-price-value">
												${buildingPriceArrar?.["insulation_calculation"] != undefined ? buildingPriceArrar?.["insulation_calculation"].custom_insulation_total_amount : 0}
											</aside>
										</li>
										<li className={buildingPriceArrar?.["insulation_calculation"] == undefined ? "d-none" : "highlight-deposit"}>
											<aside className="deposit-price-label">Sub Total</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={buildingPriceArrar?.["insulation_calculation"] != undefined ? buildingPriceArrar?.["insulation_calculation"].custom_insulation_total_amount : 0} />
											</aside>
										</li>
										<li className={buildingPriceArrar?.["insulation_calculation"] == undefined ? "d-none" : "highlight-price"}>
											<aside className="deposit-price-label">Insulation Deposit</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay
													value={buildingPriceArrar?.["insulation_calculation"] != undefined ? buildingPriceArrar?.["insulation_calculation"].custom_insulation_down_payment_total : 0}
												/>
											</aside>
										</li>
									</>
								)}

								{const_var.post_data.building != undefined
									? uniqueInsulationObjects.length > 0
										? Object.entries(const_var.thirdPartyComponent.tax.insulation)?.map((val, key) => {
												return (
													<li className="highlight-price" key={key}>
														<aside className="deposit-price-label" style={{ textTransform: "capitalize" }}>
															{val?.[1].name}
														</aside>
														<aside className="deposit-price-value">
															<CurrencyDisplay value={val[1].tax_amount ? val[1].tax_amount : 0} />
														</aside>
													</li>
												);
											})
										: Object.entries(const_var.post_data.building.tax).map((val, key) => {
												let insulationPrice = 0;
												let overheadPrice = 0;
												let commonPrice = 0;
												let BuildingINCAmount = 0;
												if (buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
													if (val[1].amount != undefined) {
														commonPrice = parseFloat(val[1].amount);
														BuildingINCAmount = val[1].amount;
													}
													if (buildingPriceArrar?.["insulation_calculation"] != undefined) {
														commonPrice = val[1].insulation_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].insulation_tax_amount) : parseFloat(commonPrice) + 0;
														insulationPrice = val[1].insulation_tax_amount != undefined ? val[1].insulation_tax_amount : 0;
													}
													if (buildingPriceArrar?.["overhead_door_calculation"] != undefined) {
														commonPrice = val[1].overhead_tax_amount != undefined ? parseFloat(commonPrice) + parseFloat(val[1].overhead_tax_amount) : parseFloat(commonPrice) + 0;
														overheadPrice = val[1].overhead_tax_amount != undefined ? val[1].overhead_tax_amount : 0;
													}
												}
												return (
													<>
														{buildingPriceArrar?.["insulation_calculation"] != undefined || buildingPriceArrar?.["overhead_door_calculation"] != undefined ? (
															<li key={key} className={buildingPriceArrar?.["insulation_calculation"] == undefined ? "d-none" : "highlight-price"}>
																<aside className="deposit-price-label">{const_var.othertaxDropDownValue[val[1].name]}</aside>
																<aside className="deposit-price-value">
																	<CurrencyDisplay value={buildingPriceArrar?.["insulation_calculation"] != undefined ? insulationPrice : 0} />
																</aside>
															</li>
														) : (
															""
														)}
													</>
												);
											})
									: null}
								{uniqueInsulationObjects.length > 0 ? (
									<>
										<li className={const_var.thirdPartyComponent?.surcharge?.insulation?.additionalValue > 0 ? "highlight-price" : "d-none"}>
											<aside className="deposit-price-label">Additional Charges</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyComponent?.surcharge?.insulation?.additionalValue || 0} />
											</aside>
										</li>
										<li className="highlight-deposit">
											<aside className="deposit-price-label">Due Amount</aside>
											<aside className="deposit-price-value">
												<CurrencyDisplay value={const_var.thirdPartyPricesObj?.insulation?.inc_due_amount || 0} />
											</aside>
										</li>
									</>
								) : (
									<li className={buildingPriceArrar?.["insulation_calculation"] == undefined ? "d-none" : "highlight-deposit"}>
										<aside className="deposit-price-label">Total</aside>
										<aside className="deposit-price-value">
											<CurrencyDisplay value={buildingPriceArrar?.["insulation_calculation"] != undefined ? buildingPriceArrar?.["insulation_calculation"].custom_insulation_total_amount : 0} />
										</aside>
									</li>
								)}
							</ul>
						</Tab>
					)}
				</Tabs>
				<div className="price-sticky-footer">
					<div className="highlight-deposit">
						<aside className="deposit-price-label">Grand Total</aside>
						<aside className="deposit-price-value">
							<CurrencyDisplay
								value={
									const_var.post_data.building != undefined && buildingPriceArrar?.["new_down_payment_total"] != undefined
										? const_var.post_data.building.due_upon_installation +
											buildingPriceArrar?.["new_down_payment_total"] +
											buildingPriceArrar?.["custom_down_payment_total"] +
											buildingPriceArrar?.["grvy_value"]
										: 0
								}
							/>
						</aside>
					</div>
					<hr />
					<div
						className={`more-information ${isMoreInfo ? "more-info-active" : ""}`}
						style={{ boxShadow: isMoreInfo ? "0px -20px 40px -15px rgba(0,0,0,0.45), 0px 20px 40px -15px rgba(0,0,0,0.45)" : "" }}
						onClick={() => moreInfoClick()}
					>
						<span>More info about Calculation!</span>
						<i className={`${!isMoreInfo ? "icon-arrow-down-ico" : "icon-cross-ico"}`}></i>
					</div>

					{const_var.post_data.building != undefined && const_var.post_data.building.tax.length == 0 ? (
						<p className="infobar">These estimates do not include taxes. Taxes to be calculated based on your location.</p>
					) : null}
				</div>
			</div>
			{isMoreInfo && (
				<div className="more-info-wrapper">
					<div className="more-info-item-container" style={{ height: totalSummaryHeight - 40 + "px" }}>
						{moreInfoList.map((item, index) => {
							return (
								<div className="info-item" key={index}>
									<div className="info-title">{item.title}</div>
									<div className="info-detail">{item.detail}</div>
									<div className="info-sub-detail">{item?.subDetail}</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</>
	);
};

export default Prices;
